module.exports = __webpack_public_path__ + "static/media/home-banner-img-2.45f45790.jpg";